export const ACCESS_TOKEN = 'accessToken';
export const ACCESS_TOKEN_EXPIRES_ON = 'accessTokenExpiresOn';
export const ACCESS_TOKEN_REFRESH_STARTED_ON = 'accessTokenRefreshStartedOn';
export const REFRESH_TOKEN = 'refreshToken';
export const ACCOUNT = 'account';

export const CODE_VERIFIER = 'codeVerifier';
export const RETURN_URL = 'returnUrl';

export const DRAWER_EXPANDED = 'drawerIsExpanded';